import './App.css';
import "bootstrap/dist/css/bootstrap.min.css";
import bootstrap from "bootstrap";
import MainPage from "./views/MainPage";

function App() {
  return (
    <MainPage />
  );
}

export default App;
